import { WidgetInstance, type WidgetInstanceOptions } from "friendly-challenge"

export function createCaptchaWidget(
    container: HTMLElement,
    doneCallback: () => void,
    customOptions: object = {},
): WidgetInstance {
    return new WidgetInstance(container, {
        ...{
            startMode: "none",
            sitekey: "FCMGFRDHPJCAQL21",
            doneCallback: doneCallback,
        },
        ...customOptions,
    } as Partial<WidgetInstanceOptions>)
}
